import * as React from 'react';
import styled, { css } from 'styled-components';

import { AquaTheme as T, isAqua } from '../../aqua/AquaTheme';
import { GlassPane } from '../../aqua/GlassPane';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;  
  
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;

  // Fired when cancel button is clicked.
  onCancel: () => void;
}

const GuideBoxBase = (props: IProps) => {
  const cross = 
    <Cross onClick={props.onCancel} title="Cancel tutorial">
      <svg>
        <use xlinkHref={"sprites.svg#times"}></use>
      </svg>            
    </Cross>;

  if(isAqua) return (
    <GlassPane bordered animated className={props.className}>
      {cross}
      {props.children}
    </GlassPane>
  );

  return (
    <div className={props.className}>
      {cross}
      {props.children}
    </div>
  );
}

const GuideBox = styled(GuideBoxBase)`
  position: absolute;
  z-index: 1;
  ${p => p.left && css`left: ${p.left};`}
  ${p => p.right && css`right: ${p.right};`}
  ${p => p.top && css`top: ${p.top};`}
  ${p => p.bottom && css`bottom: ${p.bottom};`}

  width: 250px;

  user-select: none;
  font-size: 12px;

  ${!isAqua && css`
    background: rgba(0,0,0,0.5);
    backdrop-filter: blur(3px);
    color: #fff;
  `}
  line-height: 18px;
  padding: 16px 32px 16px 24px;

  h1 {
    font-size: 18px;
    margin-bottom: 6px;
    white-space: nowrap;
    line-height: 20px;
    color: #fff;
    font-weight: normal;
  }
  strong {
    font-weight: 500;
  }
  em {
    font-style: normal;
    color: gold;
  }
  p {
    margin-bottom: 6px;
  }

  // Aqua: a GlassPane left of the layer menu button, in AquaUI type.
  ${isAqua && css`
    top: 12px;
    right: 68px;
    left: auto;
    bottom: auto;
    width: 280px;
    display: block;
    padding: 16px 40px 16px 16px;
    font: ${T.font.bodySmall};
    line-height: 18px;
    color: ${T.colors.primary[4]};
    h1 {
      font: ${T.font.headingSmall};
      color: ${T.colors.primary[5]};
      margin-bottom: 4px;
    }
    strong, b {
      font-weight: 700;
    }
    em {
      color: ${T.colors.primary[2]};
    }
    p {
      margin-bottom: 8px;
    }
  `}
`

const Cross = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  svg {
    fill: #eee;
    width: 16px;
    height: 16px;
  }
  &:hover {
    svg { 
      fill: #fff;
    }
  }
  ${isAqua && css`
    right: 12px;
    top: 12px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color ease-in-out ${T.duration}ms;
    svg, &:hover svg {
      width: 10px;
      height: 10px;
      fill: ${T.colors.primary[4]};
    }
    &:hover {
      background-color: rgba(0,0,0,0.08);
    }
  `}
`

export { GuideBox }
